import { useUserSuiWallet } from './use-user-sui-wallet';

export function useUserSuiAddress(): string | undefined {
  return useUserSuiWallet().address;
}
